import React from 'react';

function CheckIcon({ fill = '#545659', width = 18, height = 18, ...rest }) {
  return (
    <svg
      fill="#000000"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      id="check-mark-circle"
      data-name="Flat Color"
      xmlns="http://www.w3.org/2000/svg"
      className="icon flat-color"
      {...rest}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <circle id="primary" cx="12" cy="12" r="10" style={{ fill: fill }} />
        <path
          id="secondary"
          d="M11,15.5a1,1,0,0,1-.71-.29l-3-3a1,1,0,1,1,1.42-1.42L11,13.09l4.29-4.3a1,1,0,0,1,1.42,1.42l-5,5A1,1,0,0,1,11,15.5Z"
          style={{ fill: '#ffffff' }}
        />
      </g>
    </svg>
  );
}

export default CheckIcon;
